export function resolveProductGalleryDropSource(
  activeSourceId: string | null,
  targetId: string,
): string | null {
  if (!activeSourceId || activeSourceId === targetId) return null;
  return activeSourceId;
}
